import { useState } from 'react';
import { ChevronDownIcon, XMarkIcon } from '@heroicons/react/24/outline';

import IconButton from '@/components/ui/custom/buttons/IconButton';
import {
  FilterFormProps,
  TextArrowOrderingFilterProps,
} from '@/models/FilterConfig';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import SortToggle from '@/components/ui/custom/dataInput/SortToggle';

export default function TextArrowOrderingFilter(
  props: TextArrowOrderingFilterProps & FilterFormProps,
) {
  const { name, options, setValue, value, hideClear } = props;

  const [descending, ascending] = options;

  const [isDescending, setIsDescending] = useState(value === descending.value);

  const chevronIcon = (
    <figure className="w-3.5">
      <ChevronDownIcon
        className={`w-3.5 transition-all duration-150 ease-in-out transform ${
          !isDescending ? 'rotate-180' : ''
        }`}
      />
    </figure>
  );

  return (
    <fieldset className="flex gap-1 items-center">
      <SortToggle
        isDescending={isDescending}
        id="textArrowOrderingFilter"
        text={{
          ascending: ascending.label,
          descending: descending.label,
        }}
        className={{ div: 'text-base-content lowercase' }}
        icon={chevronIcon}
        hideLabel
        onToggleSort={checked => {
          setIsDescending(checked);
          setValue(name, checked ? descending.value : ascending.value);
        }}
      />
      <ConditionalRenderer condition={value !== undefined && !hideClear}>
        <IconButton
          icon={<XMarkIcon className="text-error w-4 h-4" />}
          onClick={() => setValue(name, undefined)}
        />
      </ConditionalRenderer>
    </fieldset>
  );
}
